module.exports = __webpack_public_path__ + "img/icon-ios3x.1922e66c.png";